import { render, staticRenderFns } from "./SearchResultPage.vue?vue&type=template&id=60b3fc1d&scoped=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=js"
export * from "./SearchResultPage.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPage.vue?vue&type=style&index=0&id=60b3fc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3fc1d",
  null
  
)

export default component.exports